<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Auditoría</h1>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P003T0001">
    <ng-container matColumnDef="codigo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0001">Código</th>
      <td mat-cell *matCellDef="let element">
        {{ element.codigo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="mensaje">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0002">Mensaje</th>
      <td mat-cell *matCellDef="let element">
        {{ element.mensaje }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rango1">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0003">Rango 1</th>
      <td mat-cell *matCellDef="let element">
        {{ element.rango1 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rango2">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0004">Rango 2</th>
      <td mat-cell *matCellDef="let element">
        {{ element.rango2 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="valorStr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0005">Valor Str</th>
      <td mat-cell *matCellDef="let element">
        {{ element.valorStr }}
      </td>
    </ng-container>

    <ng-container matColumnDef="variable">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P003C0006">Variable</th>
      <td mat-cell *matCellDef="let element">
        {{ element.variable }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0">No hay resultados para "{{ input.value }}"</span>
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, allData]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
